import { Signal } from "@char/aftercare";

export function viewImages(
  images: { src: string; alt: string }[],
  start: number,
): void {
  const index = new Signal(start);
  const current = index.derive((value) => images[value]);
  const overflow = document.documentElement.style.overflow;
  const scroll = { left: scrollX, top: scrollY };
  const dialog = (
    <dialog
      class="image-viewer"
      ariaLabel="Image viewer"
      _onclose={() => {
        document.documentElement.style.overflow = overflow;
        dialog.remove();
        scrollTo(scroll);
      }}
      _onclick={(event) => {
        if (event.target === dialog) dialog.close();
      }}
      _onkeydown={(event) => {
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          index.set(Math.max(0, index.get() - 1));
        } else if (event.key === "ArrowRight") {
          event.preventDefault();
          index.set(Math.min(images.length - 1, index.get() + 1));
        }
      }}
    >
      <div class="viewer-toolbar">
        <span role="status" ariaLive="polite">
          {index.derive((value) => `${value + 1} / ${images.length}`)}
        </span>
        <button
          type="button"
          autofocus
          ariaLabel="Close image viewer"
          _onclick={() => dialog.close()}
        >
          Close ×
        </button>
      </div>
      <div
        class="viewer-stage"
        _onclick={(event) => {
          if (event.target === event.currentTarget) dialog.close();
        }}
      >
        <button
          class="viewer-previous"
          type="button"
          ariaLabel="Previous image"
          hidden={images.length === 1}
          disabled={index.derive((value) => value === 0)}
          _onclick={() => index.mut((value) => value - 1)}
        >
          ‹
        </button>
        <img
          src={current.derive((image) => image.src)}
          alt={current.derive((image) => image.alt)}
          referrerPolicy="no-referrer"
        />
        <button
          class="viewer-next"
          type="button"
          ariaLabel="Next image"
          hidden={images.length === 1}
          disabled={index.derive((value) => value === images.length - 1)}
          _onclick={() => index.mut((value) => value + 1)}
        >
          ›
        </button>
      </div>
      <details
        class="viewer-alt"
        hidden={current.derive((image) => !image.alt)}
      >
        <summary>ALT</summary>
        <p>{current.derive((image) => image.alt)}</p>
      </details>
    </dialog>
  ) as HTMLDialogElement;
  document.body.append(dialog);
  dialog.showModal();
  document.documentElement.style.overflow = "hidden";
}
